import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { TabsWrap, TabsRow, Tab, TabTrack, TabIndicator } from './styled';

export const TAB_UNASSIGNED = 'unassigned';
export const TAB_MY_BOOKS = 'my-books';
export const TAB_GIFTS = 'gifts';

export const TAB_ORDER = [TAB_UNASSIGNED, TAB_MY_BOOKS, TAB_GIFTS];

const LABELS = {
  [TAB_UNASSIGNED]: 'Unassigned',
  [TAB_MY_BOOKS]: 'My Books',
  [TAB_GIFTS]: 'Gifts',
};

// The underline is a full-width track with a coloured segment sitting under the
// active label, so the segment is measured from the rendered tab rather than
// hard-coded per tab as in the Figma frames.
const DashboardTabs = ({ activeTab, counts, isLoading, onChange }) => {
  const rowRef = useRef(null);
  const tabRefs = useRef({});
  const [indicator, setIndicator] = useState({ left: '0px', width: '0px' });

  useLayoutEffect(() => {
    const row = rowRef.current;
    const node = tabRefs.current[activeTab];
    if (!row || !node) return;
    const rowBox = row.getBoundingClientRect();
    const nodeBox = node.getBoundingClientRect();
    setIndicator({
      left: `${nodeBox.left - rowBox.left}px`,
      width: `${nodeBox.width}px`,
    });
  }, [activeTab, counts]);

  return (
    <TabsWrap>
      <TabsRow ref={rowRef}>
        {TAB_ORDER.map(tab => (
          <Tab
            key={tab}
            type="button"
            active={activeTab === tab}
            aria-selected={activeTab === tab}
            role="tab"
            ref={node => {
              tabRefs.current[tab] = node;
            }}
            onClick={() => onChange(tab)}
          >
            {isLoading ? `${LABELS[tab]}` : `${LABELS[tab]}(${counts[tab] || 0})`}
          </Tab>
        ))}
      </TabsRow>
      <TabTrack>
        <TabIndicator left={indicator.left} width={indicator.width} />
      </TabTrack>
    </TabsWrap>
  );
};

DashboardTabs.propTypes = {
  activeTab: PropTypes.oneOf(TAB_ORDER).isRequired,
  counts: PropTypes.objectOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DashboardTabs;
